import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Check, X } from "lucide-react";
import api from "@/lib/api";
import useSEO from "@/lib/useSEO";

export default function Unsubscribe() {
  useSEO({ title: "Disiscrizione newsletter", description: "Gestisci le tue preferenze email Giovanna Matino Interior." });
  const [params] = useSearchParams();
  const [state, setState] = useState("loading"); // loading | ok | error

  useEffect(() => {
    const email = params.get("email") || "";
    const t = params.get("t") || "";
    api.get("/newsletter/unsubscribe", { params: { email, t } })
      .then(() => setState("ok"))
      .catch(() => setState("error"));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-[60vh] flex items-center justify-center px-6" data-testid="page-unsubscribe">
      <div className="max-w-lg w-full text-center bg-white border border-hair p-10">
        {state === "loading" && <p className="text-taupe text-sm">Un momento…</p>}
        {state === "ok" && (
          <>
            <div className="w-14 h-14 rounded-full bg-gold/10 flex items-center justify-center mx-auto"><Check size={26} className="text-gold" /></div>
            <h1 className="font-serif text-3xl mt-5">Fatto, sei disiscritto.</h1>
            <p className="text-taupe mt-4 text-sm leading-relaxed">Non riceverai più comunicazioni marketing dallo Studio. Le email di servizio (ordini, prenotazioni, documenti richiesti) restano attive perché necessarie.</p>
          </>
        )}
        {state === "error" && (
          <>
            <X size={26} className="mx-auto text-taupe" />
            <h1 className="font-serif text-3xl mt-5">Link non valido.</h1>
            <p className="text-taupe mt-4 text-sm">Il link di disiscrizione non è valido o è già stato usato. Per assistenza scrivici.</p>
          </>
        )}
        <Link to="/" className="btn-ink mt-8 inline-flex" data-testid="unsub-home">Torna alla home</Link>
      </div>
    </div>
  );
}
